export default "__VITE_ASSET__DxNtOmbu__"